import {
  FETCH_SUPPORT_REQUESTS,
  FETCH_SUPPORT_REQUESTS_SUCCESS,
  FETCH_SUPPORT_REQUESTS_FAILED,
  EDIT_SUPPORT_REQUEST
} from "../store/types";

const INITIAL_STATE = {
  supportRequests: null,
  loading: false,
  error: {
    flag: false,
    msg: null
  }
}

export const supportrequestreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_SUPPORT_REQUESTS:
      return {
        ...state,
        loading: true
      };
    case FETCH_SUPPORT_REQUESTS_SUCCESS:
      return {
        ...state,
        supportRequests: action.payload,
        loading: false
      };
    case FETCH_SUPPORT_REQUESTS_FAILED:
      return {
        ...state,
        supportRequests: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case EDIT_SUPPORT_REQUEST:
      return state;
    default:
      return state;
  }
} 